exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\nokta-widget {\n  flex-grow: 0.6;\n}\n\nfooter.mdl-mini-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0;\n  padding-left: 10px;\n}\n\n", ""]);

// exports
